$(document).ready(function() {
  var priceOne = $(".variant_price_hidden").eq(0).val();
  var comparePriceOne = $(".variant_price_hidden").eq(0).data('compare-price');
  var priceOneRaw = $(".variant_price_hidden").eq(0).val().replace(/\$/g, '');
  var comparePriceOneRaw = $(".variant_price_hidden").eq(0).data('compare-price').replace(/\$/g, '');
  var savingsOne = comparePriceOneRaw - priceOneRaw;
  var currencyCharacter = $(".variant_price_hidden").eq(0).val().charAt(0);

  $(".sale_banner_coll span.selected_currency").html(currencyCharacter);
  $(".sale_banner_coll.mandys span.discounted_price").html(savingsOne + '<br>OFF');

  $(".discounted_price").each(function() {
    var elementWidth = $(this).width;
    if (elementWidth > 40 ) {
      $(this).hide();
    }
  });
});
  
$(function(){
  $('#coll_sort_filter').on('change', function () {
      var url = $(this).val(); 
      if (url) {
          window.location = url; // redirect
      }
      return false;
  });
});

$(function(){
  $('#coll_filter_1').on('change', function () {
      var url1 = $(this).val(); 
      if (url1) {
          window.location = url1; // redirect
      }
      return false;
  });
});

$(function(){
  $('#coll_filter_2').on('change', function () {
      var url2 = $(this).val(); 
      if (url2) {
          window.location = url2; // redirect
      }
      return false;
  });
});

$(function(){
  $('#coll_filter_3').on('change', function () {
      var url3 = $(this).val(); 
      if (url3) {
          window.location = url3; // redirect
      }
      return false;
  });
});

if ($(window).width() <= 810) {
  $(".filter_option").hide();
  $(".sort_option").hide();
} else {
   $(".sort_option").show();
}

$(window).resize(function() {
  if ($(window).width() <= 810) {
    $(".filter_option").hide();
    $(".sort_option").hide();
  } else {
     $(".sort_option").show();
  }
});

$("button.show_filters").click(function() {
  $(".filter_option").toggle();
  $(".sort_option").hide();
  $(".filter_options").removeClass("toggle_height_2").toggleClass("toggle_height");
  if ($("#coll_filter_1").children("option").length <= 1) {
    $("#coll_filter_1").parent(".custom-select.filter_option").hide();
  }
  if ($("#coll_filter_2").children("option").length <= 1) {
    $("#coll_filter_2").parent(".custom-select.filter_option").hide();
  }
  if ($("#coll_filter_3").children("option").length <= 1) {
    $("#coll_filter_3").parent(".custom-select.filter_option").hide();
  }
});

$("button.show_sort").click(function() {
  $(".filter_option").hide();
  $(".sort_option").toggle();
  $(".filter_options").removeClass("toggle_height").toggleClass("toggle_height_2");
});
  
var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /* For each element, create a new DIV that will act as the selected item: */
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /* For each element, create a new DIV that will contain the option list: */
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /* For each option in the original select element,
    create a new DIV that will act as an option item: */
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
      /* When an item is clicked, update the original select box,
      and the selected item: */
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          // ================== NEW LINE TO FIRE EVENT MANUALLY =======================
          s.dispatchEvent(new window.Event("change"));
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("select-hide");
    this.classList.toggle("select-arrow-active");
  });
}

function closeAllSelect(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);

var select = document.querySelector("#cars");
select.addEventListener("change", function() {
  console.log(this.value)
});